<template>
  <div class="classManage">
    <div class="title">
      <span style="border-left: 4px solid #409eff; padding-left: 20px"
        >班级管理</span
      >
    </div>
    <div style="text-align: center">
      <el-row style="margin-bottom: 15px">
        <!-- <el-button type="primary" size="medium" style="margin-right: 10px"
          >一年级一班</el-button
        > -->
        <el-button
          v-for="(item, index) in list"
          :key="index"
          type="primary"
          size="medium"
        >
          {{ item.grade_name + item.class_name }}</el-button
        >
        <div v-show="list.length == 0">暂无管理班级</div>
      </el-row>
      <!-- <el-row style="margin-bottom: 15px">
        <el-button type="primary" size="medium" style="margin-right: 10px"
          >一年级五班</el-button
        >
        <el-button type="primary" size="medium">一年级八班</el-button>
      </el-row>
      <el-row style="margin-bottom: 15px">
        <el-button type="primary" size="medium" style="margin-right: 10px"
          >一年级五班</el-button
        >
        <el-button type="primary" size="medium">一年级八班</el-button>
      </el-row> -->
    </div>
  </div>
</template>

<script>
import URL from "@/api/index.js";
export default {
  data() {
    return {
      list: [],
    };
  },
  components: {},
  mounted() {
    this.getMasterclass();
  },

  methods: {
    getMasterclass() {
      var data = { token: JSON.parse(localStorage.getItem("loginInfo")).token };
      this.$post(URL.getMasterclass, data).then((res) => {
        if (res.result) {
          this.list = res.result;
        }
      });
    },
  },
};
</script>

<style lang='less' scoped>
.classManage {
  margin-top: 15px;
  background-color: #fff;
  padding: 0px 20px 15px;
  margin-bottom: 30px;
  border-radius: 8px;
}
.title {
  border-bottom: 1px solid #f4f4f4;
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  margin-bottom: 20px;
}
</style>
